<template>
	<transition name="fade">
		<div v-show="visible" class="tips-dialog-mask" @click.self="handleMaskClick">
			<div class="tips-dialog">
				<!-- 关闭按钮 -->
				<i class="el-icon-close dialog-close" @click="handleClose" />

				<!-- 内容区域 -->
				<div class="dialog-content">
					<div class="content-body">
						<p class="content-line">尊敬的企业用户：</p>
						<p class="content-line indent">
							您好！非常感谢您选择在湖北建设信息网进行企业宣传。在此，为了确保宣传工作的顺利进行，特向您温馨提示以下重要信息：
						</p>
						<p class="content-line">
							1、我们将在
							<span class="highlight">5个工作日</span>
							内完成对您企业宣传内容的审核及编排工作。若审核通过，相关宣传信息将立即发布至湖北建设信息网的相应页面，助力您的企业形象广泛传播。
						</p>
						<p class="content-line">
							2、若不幸审核
							<span class="highlight">未能通过</span>
							，我们将按照规定为您
							<span class="highlight link">办理退费</span>
							，您只需在订单处进行相应操作，即可完成退费流程。
						</p>
						<p class="content-line indent">
							如有任何疑问，欢迎随时与我们联系，我们将竭诚为您服务。
						</p>
						<p class="content-line indent">再次感谢您对我们工作的支持与配合！</p>
						<p class="content-line align-right">[楚建通]</p>
					</div>
				</div>

				<!-- 底部按钮 -->
				<div class="dialog-footer">
					<el-button class="know-btn" @click="handleConfirm">知道了</el-button>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
	/**
	 * @description 购买流程-温馨提示弹窗
	 */
	export default {
		name: 'TipsDialog',
		props: {
			visible: {
				type: Boolean,
				default: false
			}
		},
		watch: {
			visible(newVal) {
				if (newVal) {
					document.body.style.overflow = 'hidden'
				} else {
					document.body.style.overflow = ''
				}
			}
		},
		beforeDestroy() {
			document.body.style.overflow = ''
		},
		methods: {
			handleClose() {
				this.$emit('update:visible', false)
				this.$emit('close')
			},
			handleConfirm() {
				this.$emit('update:visible', false)
				this.$emit('confirm')
			},
			handleMaskClick() {
				this.handleClose()
			}
		}
	}
</script>

<style lang="scss" scoped>
	.tips-dialog-mask {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 2000;
		background: rgba(0, 0, 0, 0.5);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.tips-dialog {
		position: relative;
		width: 520px;
		min-height: 600px;
		background-image: url('~@/assets/mall/tips.png');
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: center top;
		padding: 130px 50px 70px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;

		// 关闭按钮
		.dialog-close {
			position: absolute;
			top: 40px;
			right: 40px;
			font-size: 24px;
			color: #214faf;
			cursor: pointer;
			z-index: 10;
			transition: color 0.3s;

			&:hover {
				color: #1a3d8f;
			}
		}

		// 内容区域
		.dialog-content {
			flex: 1;
			overflow-y: auto;
			margin-bottom: 16px;

			.content-body {
				font-size: 14px;
				color: #333;
				line-height: 1.8;

				.content-line {
					margin: 0 0 8px;

					&:last-child {
						margin-bottom: 0;
					}

					&.indent {
						text-indent: 2em;
					}

					&.align-right {
						text-align: right;
						margin-top: 12px;
					}

					.highlight {
						color: #2a66f9;
						font-weight: bold;

						&.link {
							cursor: pointer;
							text-decoration: underline;
						}
					}
				}
			}
		}

		// 底部按钮
		.dialog-footer {
			margin-top: 20px;
			text-align: center;

			.know-btn {
				width: 100%;
				height: 50px;
				background: #669deb;
				border-color: #669deb;
				border-radius: 30px;
				font-size: 20px;
				color: #ffffff;
				transition: all 0.3s;

				&:hover {
					background: #5a8fd8;
					border-color: #5a8fd8;
				}
			}
		}
	}

	// 过渡动画
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.3s;
	}

	.fade-enter,
	.fade-leave-to {
		opacity: 0;
	}
</style>
